<template>
  <el-dialog :title="title" :visible.sync="dialogVisible"  width="50%" top="5vh">
    <el-form
      :model="formInfo"
      :rules="rules"
      :inline="false"
      ref="ruleForm"
      label-width="120px"
      class="demo-form-inline"
    >
      <el-form-item label="管理员姓名" prop="name">
        <el-input v-model="formInfo.name"></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="loginName">
        <el-input v-model="formInfo.loginName"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pwd">
        <el-input type="pwd" v-model="formInfo.pwd"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio v-model="formInfo.state" :label="1">正常</el-radio>
        <!-- <el-radio v-model="formInfo.status" label="2">备选项</el-radio> -->
        <el-radio v-model="formInfo.state" :label="3">禁用</el-radio>
      </el-form-item>
      <div style="text-align: right">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button @click="dialogVisible = false">取消</el-button>
        <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
      </div>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "" },
  },
  data() {
    const validatorPhone = function (rule, value, callback) {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      formInfo: {
        merchantName: "",
        name: "",
        telNumber: "",
        pwd: "",
        status: "正常",
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        merchantName: [
          { required: true, message: "请输入商户名称", trigger: "blur" },
        ],
        loginName: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        pwd: [{ required: true, message: "请输入初始密码（密码包含大小写字母、特殊符号、数字三种即可）", trigger: "blur" }],
        state: [{ required: true, message: "请输入状态", trigger: "blur" }],
      },
    };
  },
  methods: {
    async submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.$emit("submit", {...this.formInfo,loginName:this.formInfo.tel});
          this.$emit("submit", {...this.formInfo,loginName:this.formInfo.loginName});

        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    initData() {
      this.resetForm("ruleForm");
      this.formInfo = {
        name: "",
        merchantName:'',
        loginName: "",
        pwd: "",
        state: "正常",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 30px;
}
@import "~@/style/dialog.scss";
</style>